import { css } from '@bts-web/utils-style-engine';
import { TradeScreenTranslations } from '../../utils/getTradeTranslations';
import { TFunction } from 'i18next';
import { formattedAmount } from '../../../orders/components/CurrencyFormatting';

export const TransferLoading = ({
  translations,
  isResume,
  t,
  amount,
}: {
  translations: TradeScreenTranslations;
  isResume: boolean;
  t: TFunction<'translation', undefined>;
  amount?: string;
}) => {
  let formattedFiat = '0';

  if (amount) {
    formattedFiat = formattedAmount({ value: amount, precision: 2 });
  }

  return (
    <>
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          gap: 'large',
          marginBottom: '10px',
        })}
      >
        <svg
          data-element="loading-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="39"
          height="39"
          viewBox="0 0 39 39"
          fill="none"
          aria-label="loading"
        >
          <path
            d="M19.1998 5.76C11.7771 5.76 5.75984 11.7773 5.75984 19.2C5.75984 19.7302 5.33004 20.16 4.79984 20.16C4.26965 20.16 3.83984 19.7302 3.83984 19.2C3.83984 10.7169 10.7168 3.84 19.1998 3.84C27.6829 3.84 34.5598 10.7169 34.5598 19.2C34.5598 27.6831 27.6829 34.56 19.1998 34.56C18.6697 34.56 18.2398 34.1302 18.2398 33.6C18.2398 33.0698 18.6697 32.64 19.1998 32.64C26.6226 32.64 32.6398 26.6227 32.6398 19.2C32.6398 11.7773 26.6226 5.76 19.1998 5.76Z"
            fill="#282828"
          />
        </svg>
      </div>
      <p
        className={css({
          fontSize: 'headline.large_semi_bold',
          fontWeight: 'headline.large_semi_bold',
          lineHeight: 'headline.large_semi_bold',
          letterSpacing: 'headline.large_semi_bold',
          textAlign: 'center',
          margin: '0',
        })}
      >
        {isResume
          ? translations.fiatTransferResumingTitle
          : translations.fiatTransferLoadingTitle}
      </p>
      <p
        className={css({
          fontSize: 'body.medium_medium',
          fontWeight: 'body.medium_medium',
          lineHeight: 'body.medium_medium',
          letterSpacing: 'body.medium_medium',
          textAlign: 'center',
          margin: '0',
          color: 'neutrals.text_secondary',
        })}
      >
        {isResume && amount
          ? t(translations.fiatTransferResumingSubtitle, {
              amount: formattedFiat,
            })
          : translations.fiatTransferLoadingSubtitle}
      </p>
    </>
  );
};
